export const keys = {
  siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY
};
